import { SunAngleIcon } from './SunAngleIcon';

/**
 * author: Michael Irigoyen
 * id 18B8F0B3-FEE0-4DF6-A6FB-701BCAB19F3A
 * name sun-angle
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-angle.svg
 * tags
 * - Weather 
 */
export const SolarAngleIcon = SunAngleIcon;
export default SolarAngleIcon